'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _reactTransitionGroup = require('react-transition-group');

var _wrappers = require('../wrappers');

var _Sidebar = require('./Sidebar.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sidebar = exports.Sidebar = function Sidebar(_ref) {
  var className = _ref.className,
      onOverlayClick = _ref.onOverlayClick,
      children = _ref.children,
      open = _ref.open,
      timeout = _ref.timeout;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      _reactTransitionGroup.TransitionGroup,
      null,
      open && _react2.default.createElement(
        _reactTransitionGroup.CSSTransition,
        {
          timeout: timeout,
          classNames: 'fade-slide'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'overlay',
            onClick: onOverlayClick },
          _react2.default.createElement(
            'div',
            {
              className: 'sidebar',
              onClick: function onClick(e) {
                return e.stopPropagation();
              } },
            children
          )
        )
      )
    )
  );
};

Sidebar.propTypes = {
  /**
  * Attach function to escape key while mounted.
  */
  onEscKeyDown: _propTypes2.default.func, // eslint-disable-line
  /**
   * Function to call when clicking outside the Sidebar.
   */
  onOverlayClick: _propTypes2.default.func,
  /**
   * glamorous className
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * content to render inside sidebar
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * bool to determine if sidebar is closed
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * number used for configuring animation (defaults to 400)
   */
  timeout: _propTypes2.default.number
};

Sidebar.defaultProps = {
  timeout: 400
};

exports.default = (0, _wrappers.escapable)((0, _glamorous2.default)(Sidebar)(_Sidebar.defaultStyle, _Sidebar.mapTransitionsToStyle, _Sidebar.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Sidebar/Sidebar.js
// module id = 546
// module chunks = 0